var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "" } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { left: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var on = ref.on
                return [
                  _c(
                    "v-icon",
                    _vm._g(
                      { attrs: { color: _vm.currentStatusItem.color } },
                      on
                    ),
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.currentStatusItem.icon) +
                          "\n      "
                      )
                    ]
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.currentStatusItem.tooltipText))])
        ]
      ),
      _vm._v(" "),
      _vm.delayed
        ? _c(
            "v-tooltip",
            {
              attrs: { right: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      return [
                        _c(
                          "v-icon",
                          _vm._g({ attrs: { color: "error" } }, on),
                          [_vm._v("\n        priority_high\n      ")]
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                723987214
              )
            },
            [
              _vm._v(" "),
              _c("span", [_vm._v(_vm._s(_vm.$t("DelayedAdjective")))])
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24559066", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24559066","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FieldManagement/StatusIcon.vue
// module id = null
// module chunks = 